import { create } from 'zustand'
import { DealBuilder } from '../deal-builder/services/deal-builder';

interface DealBuilderResultStore {
  loading: boolean,
  setLoading: (loading: boolean) => void,
  DealBuilderService?: DealBuilder,  
  setDealBuilderService: (dealBuilderService: DealBuilder | undefined) => void,
  resetCopy?: DealBuilder,  
  setResetCopy: (dealBuilderService: DealBuilder | undefined) => void,
}

const useDealBuilderResultStore = create<DealBuilderResultStore>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }),

  DealBuilderService: undefined,
  setDealBuilderService: (DealBuilderService: DealBuilder | undefined) => set({ DealBuilderService }),
  
  resetCopy: undefined,
  setResetCopy: (resetCopy: DealBuilder | undefined) => set({ resetCopy }),
}));

export default useDealBuilderResultStore;
